import { defineStore } from 'pinia'
import { ref } from 'vue'
import { adminWalletApi } from '@/https/api_admin/wallet'
import type { WalletTransactionItem } from '@/https/types/wallet'
import type { AdminWalletListRequest, AdminManualRechargeRequest } from '@/https/types_admin/wallet'

export const useAdminWalletStore = defineStore('adminWallet', () => {
    const list = ref<WalletTransactionItem[]>([])
    const pagination = ref({ total: 0, page: 1, size: 20, has_more: false })
    const loading = ref(false)
    const error = ref<string | null>(null)

    const loadTransactions = async (params?: AdminWalletListRequest) => {
        try {
            loading.value = true
            error.value = null
            const res = await adminWalletApi.getTransactionList(params)
            list.value = res.items
            pagination.value = { total: res.total, page: res.page, size: res.size, has_more: res.has_more }
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : '加载钱包流水失败'
            error.value = message
            throw err
        } finally {
            loading.value = false
        }
    }

    const manualRecharge = async (data: AdminManualRechargeRequest) => {
        try {
            loading.value = true
            await adminWalletApi.manualRecharge(data)
            await loadTransactions({ page: 1 })
        } catch (e) {
            throw e
        } finally {
            loading.value = false
        }
    }

    return {
        list,
        pagination,
        loading,
        error,
        loadTransactions,
        manualRecharge,
    }
})


